
import { formatPrice } from '@/core';
import {
  Prop,
  Watch,
  Vue,
  Component,
  Emit
} from 'vue-property-decorator';
import { SliderChange } from '@/constant'
import { isMobile, isTablet , isFirefox } from 'mobile-device-detect';
@Component
export default class RangeSlider extends Vue {
  private sliderMinValue = 0 as number;
  private sliderMaxValue = 0 as number;
  private formattedSliderMinValue = '';
  private formattedSliderMaxValue = '';
  private step = SliderChange;
  private zIndexLeft = 9;
  private zIndexRight = 20;
  private hasMobile = !!(isMobile && !isTablet);
  private isMobile = isMobile;
  private isFirefox = isFirefox;
  private isPriceChanged = false;
  @Prop() private max!: number;
  @Prop() private min!: number;
  @Prop() private showMinRangeOnSlider!: number;
  @Prop() private showMaxRangeOnSlider!: number;
  @Emit("clearPriceFilter")clearPriceFilter(minShow: number, maxShow: number) { }
  @Emit("applyPriceFilter")applyPriceFilter(minShow: number, maxShow: number) { }
  @Emit("updatePriceRangeMobile") updatePriceRangeMobile(minValue: number,maxValue: number){}
  @Emit("closePriceRange")closePriceRange(){}
  beforeMount() {
    this.sliderMinValue = this.showMinRangeOnSlider;
    this.sliderMaxValue = this.showMaxRangeOnSlider;
  }
  mounted() {
    this.changeLeft();
    this.changeRight();
  }
  updateLeftPercentage(percentageValue: number){
      if(percentageValue > 0 && percentageValue < 80 && !this.hasMobile){
        percentageValue -= 4;
      }else if(percentageValue > 80 && !this.hasMobile){
        percentageValue -= 8;
    }else if(percentageValue > 80 && this.hasMobile){
      percentageValue -= 2;
    }
    return percentageValue;
  }
  updateRightPercentage(percentageValue: number){
    if(percentageValue > 0 && this.hasMobile){
      percentageValue -= 4;
    }else if(percentageValue > 80 && !this.hasMobile){
      percentageValue -= 4;
    }
    return percentageValue;
  }
  updateZIndex(left: number,right :number){
    this.zIndexLeft = left;
    this.zIndexRight = right;  
    if(this.hasMobile){
      this.updatePriceRangeMobile(this.sliderMinValue,this.sliderMaxValue);
    }
    if(this.isPriceChanged){
      this.applyPriceFilter(this.sliderMinValue, this.sliderMaxValue);
    }
  }
  changeLeft() {
    const thumb_left = this.$refs.minSlider as any;
    const thumb_right = this.$refs.maxSlider as any;
    thumb_left.value = Math.min(parseInt(thumb_left.value), parseInt(thumb_right.value) - this.step);
    this.sliderMinValue = parseInt(thumb_left.value)
    let percentageValue = ((this.sliderMinValue- this.min) / (this.max - this.min)) * 100;
    percentageValue= this.updateLeftPercentage(percentageValue);
    (this.$refs.range as any).style.width = (percentageValue) + '%';
    (this.$refs.left as any).style.left = (percentageValue) + '%';
    this.formattedSliderMinValue = formatPrice(this.sliderMinValue);
    if(this.sliderMinValue > this.min && !this.isPriceChanged){
      this.isPriceChanged = true
    }
    this.updateZIndex(20,9);
  }
  changeRight() {
    const thumb_left = this.$refs.minSlider as any;
    const thumb_right = this.$refs.maxSlider as any;
    thumb_right.value = Math.max(parseInt(thumb_left.value) + this.step, parseInt(thumb_right.value))
    this.sliderMaxValue = parseInt(thumb_right.value);
    let percentageValue = ((thumb_right.max - thumb_right.value) / (thumb_left.max - thumb_left.min)) * 100;
    percentageValue= this.updateRightPercentage(percentageValue);
    (this.$refs.range1 as any).style.width = (percentageValue) + '%';
    (this.$refs.right as any).style.left = (100 - (percentageValue)) + '%';
    this.formattedSliderMaxValue = formatPrice(this.sliderMaxValue);
    if(this.sliderMaxValue < this.max && !this.isPriceChanged){
      this.isPriceChanged = true
    }
    this.updateZIndex(9,20);
  }
  setToInitialRangeSlider() {
    this.sliderMinValue = this.min;
    this.sliderMaxValue = this.max;
    const thumb_left = this.$refs.minSlider as any;
    const thumb_right = this.$refs.maxSlider as any;
    thumb_left.value = this.min;
    thumb_right.value = this.max;
    this.changeLeft();
    this.changeRight();
    this.clearPriceFilter(0, 0);
    this.isPriceChanged = false;
  }
  calculate() {
    this.closePriceRange();
  }
}
